import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './css/base.css'
import VueLazyload from 'vue-lazyload';
// const history = require('connect-history-api-fallback');
// Vue.use(history());
Vue.use(VueLazyload);
Vue.config.productionTip = false;

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
